import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentWaybillCommentsFacade } from './shipment-waybill-comments.facade';
import { WaybillIdView } from '../../../../models/shipment-id-view.model';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillCommentsGuard {
  constructor(
    private shipmentWaybillCommentsFacade: ShipmentWaybillCommentsFacade,
    private shipmentWaybillItemFacade: ShipmentWaybillItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$.pipe(
      switchMap((identifier: WaybillIdView) => {
        return checkStoreState(this.shipmentWaybillCommentsFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillCommentsFacade);
  }
}
